import { useEffect, useState } from "react";

/**
 * Ported from the shadcn Sidebar reference — the Sidebar primitive itself
 * needs this for its mobile-vs-desktop rendering branch (Sheet on mobile,
 * fixed column on desktop). Tailwind's standard `md` breakpoint (768px),
 * not the app's earlier 600px Flutter-parity threshold — see
 * MIGRATION.md.
 */
const MOBILE_BREAKPOINT = 768;

export function useIsMobile(): boolean {
  // Computed eagerly in the initializer rather than resolved via an effect
  // (as the reference does): that two-step dance exists there to avoid a
  // Next.js server/client hydration mismatch, which doesn't apply to a
  // pure client SPA — reading window.innerWidth on first render is safe
  // and correct here, and avoids an extra render on mount.
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < MOBILE_BREAKPOINT);

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
